var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-character-item"},[_c('div',{staticClass:"avatar"},[_c('head-image',{attrs:{"url":_vm.templateCharacter.avatar,"name":_vm.templateCharacter.name}})],1),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(_vm.templateCharacter.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }